import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.0669 5.47329C2.00441 5.41132 1.95482 5.33758 1.92097 5.25634C1.88713 5.1751 1.8697 5.08797 1.8697 4.99996C1.8697 4.91195 1.88713 4.82481 1.92097 4.74357C1.95482 4.66233 2.00441 4.5886 2.0669 4.52663L5.1269 1.47329C5.18938 1.41132 5.23898 1.33758 5.27283 1.25634C5.30667 1.1751 5.3241 1.08797 5.3241 0.999959C5.3241 0.911951 5.30667 0.824814 5.27283 0.743574C5.23898 0.662335 5.18938 0.588601 5.1269 0.526625C5.00199 0.402458 4.83302 0.332764 4.6569 0.332764C4.48078 0.332764 4.31181 0.402458 4.1869 0.526625L1.1269 3.58663C0.752364 3.96163 0.541992 4.46996 0.541992 4.99996C0.541992 5.52996 0.752364 6.03829 1.1269 6.41329L4.1869 9.47329C4.31107 9.59645 4.47867 9.66589 4.65357 9.66663C4.7413 9.66713 4.82828 9.65032 4.9095 9.61714C4.99073 9.58396 5.06461 9.53508 5.1269 9.47329C5.18938 9.41132 5.23898 9.33758 5.27283 9.25634C5.30667 9.1751 5.3241 9.08797 5.3241 8.99996C5.3241 8.91195 5.30667 8.82481 5.27283 8.74357C5.23898 8.66233 5.18938 8.5886 5.1269 8.52663L2.0669 5.47329Z"
      fill="#151718"
    />
  </svg>
);

const DateNavigatorLeft = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default DateNavigatorLeft;
